import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4982dc08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Choose event types", -1))
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "search-field",
  class: "input-group-addon"
}, "Search:", -1))
const _hoisted_5 = { class: "event-type-list" }
const _hoisted_6 = ["id", "value"]
const _hoisted_7 = ["for"]

import { computed, ref } from "vue";
import { Modal } from "uiv";
import LoadingSpinner from "../loading-spinner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'event-type-picker-modal',
  props: {
    eventTypes: {}
  },
  emits: ["add-selected-events"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const selectedEventTypes = ref<string[]>([]);

const shown = ref(false);

const searchInput = ref("");

function openModal(): void {
  shown.value = true;
}

function closeModal(): void {
  shown.value = false;
  searchInput.value = "";
}

function addSelectedEvents(): void {
  emit("add-selected-events", selectedEventTypes.value);
  shown.value = false;
  searchInput.value = "";
}

function clearSelection(): void {
  selectedEventTypes.value = [];
}

const searchFilteredEventTypes = computed(() => {
  if (!props.eventTypes) return [];
  return props.eventTypes.filter((event) => {
    return event.toLowerCase().includes(searchInput.value.toLowerCase());
  });
});

__expose({
  openModal,
  closeModal,
  clearSelection,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Modal), {
    modelValue: shown.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shown).value = $event)),
    header: false
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", { class: "controls center-flex" }, [
        _createElementVNode("button", {
          class: "btn btn-default",
          onClick: closeModal,
          type: "button"
        }, "Cancel"),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: addSelectedEvents,
          type: "button"
        }, "OK")
      ])
    ]),
    default: _withCtx(() => [
      (!_ctx.eventTypes)
        ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.eventTypes)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInput).value = $event)),
                class: "form-control"
              }, null, 512), [
                [_vModelText, searchInput.value]
              ])
            ]),
            _createElementVNode("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchFilteredEventTypes.value, (eventType, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: eventType,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedEventTypes).value = $event)),
                    value: eventType
                  }, null, 8, _hoisted_6), [
                    [_vModelCheckbox, selectedEventTypes.value]
                  ]),
                  _createElementVNode("label", { for: eventType }, _toDisplayString(eventType), 9, _hoisted_7)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})